import { MaestroAPI } from '@michelin/central-provider';
import GLOBAL_CONFIG from '../../global-variables';

const baseURL = GLOBAL_CONFIG.externalAPIUrl;

export function mechanicalList(fleet_id: string): MaestroAPI {
  const endpoint = `cp-be/mechanicals/${fleet_id}`;
  return { method: 'GET', endpoint, baseURL };
}
